/* ============================================================
   HOOK LIBRARY — SESAAT Studio v3.9   (PROTOTAIP · ADMIN SAHAJA)
   ============================================================
   Lead magnet "Hook Library" — rujuk PLAN_HOOK_LEADMAGNET.md.

   · TIADA LOGIC — tiada Firestore, tiada service, tiada kesan pada
     Generate. Data dummy tertulis dalam fail ini sendiri; setiap
     butang mati. Satu-satunya `useState` ialah SUIS PRATONTON di
     kepala halaman (lihat di bawah) — ia menukar rupa sahaja.
   · ADMIN SAHAJA — route '/hooks' dipagar `isAdmin` dalam App.jsx,
     DAN item menu 'hooks' dipagar `admin: true` dalam StudioShell.
   · Teks UI dalam kamus (kunci `hooks.*`, 2026-09-23) — pil bahasa
     pada kepala halaman kini HIDUP. Ayat UI baharu WAJIB masuk en.js +
     ms.js. ⚠️ Ayat HOOK itu sendiri (HOOKS, HOOKS_KABUR) SENGAJA kekal
     BM dalam kedua-dua bahasa — itulah produknya: hook Bahasa Melayu
     untuk affiliate Malaysia. Jangan terjemah.
   · Kelas berawalan .hkp- dan CSS duduk dalam fail ini — halaman
     lain sifar sentuhan. ⛔ Jangan guna awalan .s- untuk kelas
     BAHARU di sini: itu milik sistem reka bentuk, dan halaman ini
     akan pecah SENYAP bila sesiapa menyunting design/ui.css.

   ⭐ SUIS PRATONTON — kenapa ia wujud (arahan user 2026-08-17:
      "user akan login dan akses hooks ni"):
      Halaman ini hidup dalam DUA konteks, dan rupanya TIDAK sama:
        · 'app'  — pelanggan sudah log masuk. Library terbuka penuh;
                   yang berbayar ialah menjadikannya video.
        · 'awam' — pelawat dari TikTok yang belum ada akaun. Separuh
                   berkunci + CTA daftar (inilah lead magnet itu).
      Satu halaman dengan suis, bukan dua fail: dua salinan pasti
      terpesong, dan kita masih menilai reka bentuk kedua-duanya.
      ⚠️ Bila versi sebenar dibina nanti, keadaan ini datang daripada
         status log masuk — BUKAN daripada suis ini.

   · NAK PADAM: buang fail ini + import + baris route '/hooks' dalam
     App.jsx + item menu 'hooks' dalam design/StudioShell.jsx.
   ============================================================ */

import { useState } from 'react';
import {
  Copy, Check, Lock, Heart, Play, Wand2, ArrowRight, Link2, Search,
  Sparkles, Layers, Rocket, Users, CalendarDays,
} from 'lucide-react';

import '../design/tokens.css';
import { PageHeader, Segmented } from '../design/ui';
import { useT } from '../i18n';

/* Niche — `kunci: true` hanya berkesan dalam mod 'awam'. Selepas log
   masuk semuanya terbuka: library ialah lead magnet PERCUMA, dan yang
   berbayar ialah menjadikan hook itu video. */
/* `id` = kunci kamus `hooks.niche.<id>` / `hooks.cat.<id>`. Kad hook di
   bawah merujuk id yang SAMA supaya label cip dan tag kad sentiasa sepadan. */
const NICHE = [
  { id: 'all' }, { id: 'beauty' }, { id: 'fashion' },
  { id: 'parenting', kunci: true }, { id: 'food', kunci: true },
  { id: 'gadget', kunci: true }, { id: 'health', kunci: true },
  { id: 'home', kunci: true },
];

const KATEGORI = [
  'all', 'urgency', 'sales', 'review', 'curiosity', 'warning', 'pov', 'story',
];

/* 9 kad contoh. `disalin` = satu kad dipapar dalam keadaan selepas
   salin, supaya rupa maklum balas itu boleh dinilai tanpa logic. */
const HOOKS = [
  { kategori: 'urgency', niche: 'general', teks: 'Stok baru restock pagi tadi — biasanya tak sampai maghrib dah habis 😰' },
  { kategori: 'review', niche: 'beauty', teks: 'Aku beli sebab teracun. Sekarang aku pula yang meracun korang 😌', disalin: true },
  { kategori: 'pov', niche: 'general', teks: 'POV: Gaji baru masuk dan TikTok Shop macam dah tahu apa kau nak 😩' },
  { kategori: 'warning', niche: 'general', teks: 'Jangan beli sebelum korang tengok video ni sampai habis 🛑' },
  { kategori: 'curiosity', niche: 'fashion', teks: 'Cuba teka berapa harga benda ni. Salah — lagi rendah dari tu 😏' },
  { kategori: 'sales', niche: 'general', teks: 'Free shipping + voucher + free gift — seller ni memang tak nak untung ke? 🎁' },
  { kategori: 'trending', niche: 'gadget', teks: 'Earbuds bawah RM50 yang sound quality macam AirPods? Yes! 🎧' },
  { kategori: 'story', niche: 'parenting', teks: 'Aku belikan untuk mak. Reaksi dia buat aku terus rekod video ni 🥺' },
  { kategori: 'solution', niche: 'home', teks: 'Rumah bersepah bukan sebab korang malas — korang cuma tiada sistem 📦' },
];

/* Kad di belakang tirai — sengaja tidak boleh dibaca penuh. */
const HOOKS_KABUR = [
  'Repeat order kali ketiga — benda tak bagus aku takkan beli 3 kali',
  'Kenapa benda ni asyik naik FYP aku? Lepas beli, baru aku faham',
  'Harga kedai vs harga TikTok Shop — korang kira sendiri',
  'Sorok parcel sebelum family nampak — korang faham-faham je lah',
  'Aku test 30 hari supaya korang tak payah buang duit test sendiri',
  'Bundle ni kira macam beli satu, yang kedua datang free',
];

/* `k` = awalan kunci kamus: `<k>.title` + `<k>.desc`. */
const LANGKAH = [
  { Ikon: Sparkles, k: 'hooks.step1' },
  { Ikon: Layers, k: 'hooks.step2' },
  { Ikon: Rocket, k: 'hooks.step3' },
];

const KELEBIHAN_EJEN = ['hooks.agent.perk1', 'hooks.agent.perk2', 'hooks.agent.perk3'];

/* Semua warna daripada token --s-* supaya halaman ini bertukar sendiri
   mengikut tema terang/gelap. ⛔ Jangan masukkan nilai hex tetap di
   sini — ia akan hilang atau menyilaukan pada tema yang satu lagi. */
const GAYA = `
.hkp-nota{display:flex;align-items:flex-start;gap:9px;font-size:12.5px;line-height:1.6;color:var(--s-ink-2);background:var(--s-fill);border:1px solid var(--s-line);border-radius:var(--s-r);padding:10px 13px;margin-bottom:18px}
.hkp-bar{display:flex;gap:10px;align-items:center;background:var(--s-card);border:1px solid var(--s-line);border-radius:var(--s-r-lg);padding:11px 14px;flex-wrap:wrap}
.hkp-cari{display:flex;align-items:center;gap:9px;flex:1;min-width:220px;background:var(--s-fill);border:1px solid var(--s-line);border-radius:var(--s-r);padding:9px 12px;color:var(--s-ink-3);font-size:13.5px}
.hkp-meter{display:inline-flex;align-items:center;gap:8px;font-size:12.5px;font-weight:500;background:var(--s-fill);border-radius:999px;padding:7px 13px;color:var(--s-ink);white-space:nowrap}
.hkp-meter u{display:inline-flex;gap:3px;text-decoration:none}
.hkp-meter u i{width:14px;height:5px;border-radius:3px;background:var(--s-ink)}
.hkp-meter u i.off{background:var(--s-line-strong)}
.hkp-tapis{display:flex;gap:6px;align-items:center;flex-wrap:wrap;margin-top:12px}
.hkp-tapis-label{font-size:11px;font-weight:600;letter-spacing:.07em;text-transform:uppercase;color:var(--s-ink-3);margin-right:4px}
.hkp-chip{display:inline-flex;align-items:center;gap:6px;font-size:12.5px;font-weight:500;border-radius:999px;padding:6px 13px;border:1px solid var(--s-line);background:var(--s-card);color:var(--s-ink-2);cursor:pointer}
.hkp-chip:hover{border-color:var(--s-line-strong);color:var(--s-ink)}
.hkp-chip--aktif{background:var(--s-primary);border-color:var(--s-primary);color:var(--s-primary-ink)}
.hkp-chip--kunci{color:var(--s-ink-3);background:transparent;cursor:default}
.hkp-chip--kunci:hover{border-color:var(--s-line);color:var(--s-ink-3)}
.hkp-jampi{display:flex;align-items:center;gap:12px;background:var(--s-card);border:1px dashed var(--s-line-strong);border-radius:var(--s-r-lg);padding:12px 15px;margin-top:12px;flex-wrap:wrap}
.hkp-jampi b{display:block;font-size:13.5px;font-weight:600;color:var(--s-ink)}
.hkp-jampi span{font-size:12.5px;color:var(--s-ink-3)}
.hkp-kuncilabel{display:inline-flex;align-items:center;gap:6px;font-size:12px;color:var(--s-ink-3);white-space:nowrap}
.hkp-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(255px,1fr));gap:12px;margin-top:14px}
.hkp-kad{display:flex;flex-direction:column;gap:10px;background:var(--s-card);border:1px solid var(--s-line);border-radius:var(--s-r-lg);padding:14px 15px;transition:border-color .15s}
.hkp-kad:hover{border-color:var(--s-line-strong)}
.hkp-kad-atas{display:flex;align-items:center;justify-content:space-between;gap:8px}
.hkp-tag{font-size:11px;font-weight:600;background:var(--s-fill);color:var(--s-ink-2);border-radius:999px;padding:3px 9px}
.hkp-tag--niche{background:transparent;border:1px solid var(--s-line);color:var(--s-ink-3);font-weight:500}
.hkp-kad p{margin:0;font-size:14.5px;line-height:1.55;font-weight:500;color:var(--s-ink);flex:1}
.hkp-kad-bawah{display:flex;gap:7px}
.hkp-b{display:inline-flex;align-items:center;justify-content:center;gap:6px;flex:1;white-space:nowrap;font-size:12.5px;font-weight:500;padding:8px 10px;border-radius:var(--s-r);border:1px solid var(--s-line-strong);background:var(--s-card);color:var(--s-ink);cursor:pointer;transition:background .15s}
.hkp-b:hover{background:var(--s-fill)}
.hkp-b--siap{background:var(--s-fill);border-color:transparent;color:var(--s-ink-2);cursor:default}
/* "Salin" mengecut kepada saiz kandungannya supaya "Jadikan video" (tindakan
   utama) dapat baki ruang — tanpa ini labelnya berpatah dua baris pada lajur
   sempit. */
.hkp-b--kecil{flex:0 0 auto;padding:8px 12px}
.hkp-suka{border:none;background:transparent;color:var(--s-ink-3);cursor:pointer;padding:2px;display:inline-flex}
.hkp-suka:hover{color:var(--s-ink)}
.hkp-tirai{position:relative;border:1px solid var(--s-line);border-radius:var(--s-r-lg);overflow:hidden;margin-top:14px;background:var(--s-card)}
.hkp-tirai-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(230px,1fr));gap:12px;padding:16px;filter:blur(5px);opacity:.5;pointer-events:none;user-select:none}
.hkp-tirai-kad{background:var(--s-card);border:1px solid var(--s-line);border-radius:var(--s-r);padding:13px;font-size:13px;line-height:1.5;font-weight:500;color:var(--s-ink)}
.hkp-tudung{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:9px;text-align:center;padding:22px}
.hkp-tudung h3{margin:0;font-size:19px;font-weight:600;color:var(--s-ink)}
.hkp-tudung p{margin:0;font-size:13.5px;color:var(--s-ink-2);max-width:420px;line-height:1.6}
.hkp-cta{display:inline-flex;align-items:center;gap:8px;font-size:13.5px;font-weight:500;padding:9px 17px;border-radius:var(--s-r);border:1px solid var(--s-primary);background:var(--s-primary);color:var(--s-primary-ink);cursor:pointer}
.hkp-cta:hover{background:var(--s-primary-hover)}
.hkp-seksyen{margin-top:40px}
.hkp-kepala{text-align:center;max-width:560px;margin:0 auto}
.hkp-kepala h2{font-size:21px;font-weight:600;color:var(--s-ink);margin:0}
.hkp-kepala p{font-size:14px;color:var(--s-ink-2);line-height:1.65;margin:8px 0 0}
.hkp-langkah{display:grid;grid-template-columns:repeat(auto-fit,minmax(215px,1fr));gap:12px;margin-top:20px}
.hkp-langkah-kad{background:var(--s-card);border:1px solid var(--s-line);border-radius:var(--s-r-lg);padding:18px}
.hkp-langkah-ikon{display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;border-radius:var(--s-r);background:var(--s-fill);color:var(--s-ink);margin-bottom:11px}
.hkp-langkah-kad b{display:block;font-size:14.5px;font-weight:600;color:var(--s-ink)}
.hkp-langkah-kad span{display:block;font-size:13px;color:var(--s-ink-2);line-height:1.6;margin-top:5px}
.hkp-ejen{background:var(--s-primary);color:var(--s-primary-ink);border-radius:var(--s-r-lg);padding:28px;margin-top:40px;display:grid;grid-template-columns:1.15fr .85fr;gap:26px;align-items:center}
.hkp-ejen-pil{display:inline-flex;align-items:center;gap:7px;font-size:11px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:var(--s-primary-ink-2);background:var(--s-primary-fill);border-radius:999px;padding:5px 11px}
.hkp-ejen h2{font-size:21px;font-weight:600;margin:12px 0 0;color:var(--s-primary-ink)}
.hkp-ejen ul{margin:14px 0 0;padding:0;list-style:none;display:flex;flex-direction:column;gap:9px}
.hkp-ejen li{display:flex;gap:9px;font-size:13.5px;line-height:1.6;color:var(--s-primary-ink-2)}
.hkp-ejen li svg{flex:none;margin-top:2px}
.hkp-ejen-kanan{background:var(--s-primary-fill);border:1px solid var(--s-primary-line);border-radius:var(--s-r);padding:17px}
.hkp-ejen-kanan b{display:block;font-size:12.5px;font-weight:600;color:var(--s-primary-ink-2)}
.hkp-link{display:flex;align-items:center;gap:8px;background:var(--s-primary-fill);border:1px solid var(--s-primary-line);border-radius:var(--s-r-sm);padding:10px 12px;margin-top:9px;font-size:12.5px;font-family:var(--s-mono);color:var(--s-primary-ink);overflow:hidden}
.hkp-link span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.hkp-b--ejen{width:100%;margin-top:9px;background:var(--s-primary-ink);border-color:var(--s-primary-ink);color:var(--s-primary)}
.hkp-b--ejen:hover{background:var(--s-primary-ink);opacity:.9}
.hkp-ejen-nota{font-size:11.5px;color:var(--s-primary-ink-2);margin:9px 0 0;line-height:1.55}
@media (max-width:767px){
  .hkp-ejen{grid-template-columns:1fr;padding:20px}
  .hkp-bar{flex-direction:column;align-items:stretch}
  .hkp-meter{justify-content:center}
}
`;

export default function HooksV39View() {
  const t = useT();
  /* 'app' = pelanggan sudah log masuk · 'awam' = pelawat belum daftar.
     Lihat nota SUIS PRATONTON di kepala fail. */
  const [mod, setMod] = useState('app');
  const awam = mod === 'awam';

  return (
    <div className="sesaat-m-tight" style={{ padding: '26px 28px 48px' }}>
      <style>{GAYA}</style>

      <PageHeader
        title="Hook Library"
        subtitle={t('hooks.subtitle')}
        actions={
          <Segmented
            value={mod}
            onChange={setMod}
            options={[
              { value: 'app', label: t('hooks.mode.app') },
              { value: 'awam', label: t('hooks.mode.public') },
            ]}
          />
        }
      />

      <div className="hkp-nota">
        <Lock size={14} strokeWidth={1.9} style={{ flex: 'none', marginTop: 2 }} />
        <span>
          <b style={{ fontWeight: 600 }}>{t('hooks.proto.title')}</b>{' '}
          {t('hooks.proto.desc')}
        </span>
      </div>

      {/* Bar carian + meter. Meter salinan hanya wujud untuk pelawat —
          selepas log masuk tiada had, jadi ruang itu memapar saiz library. */}
      <div className="hkp-bar">
        <div className="hkp-cari">
          <Search size={15} strokeWidth={1.9} />
          <span>{t('hooks.searchPh')}</span>
          <span style={{ flex: 1 }} />
          {awam && <span className="hkp-kuncilabel"><Lock size={12} strokeWidth={1.9} /> {t('hooks.freeAccount')}</span>}
        </div>
        {awam ? (
          <span className="hkp-meter">
            {t('hooks.meter.free')}
            <u><i /><i /><i /><i className="off" /><i className="off" /></u>
            3/5
          </span>
        ) : (
          <span className="hkp-meter">{t('hooks.meter.size', { hook: 834, niche: 8, kategori: 12 })}</span>
        )}
      </div>

      <div className="hkp-tapis">
        <span className="hkp-tapis-label">{t('hooks.filter.niche')}</span>
        {NICHE.map((n, i) => (
          awam && n.kunci
            ? <span key={n.id} className="hkp-chip hkp-chip--kunci"><Lock size={11} strokeWidth={1.9} /> {t(`hooks.niche.${n.id}`)}</span>
            : <button type="button" key={n.id} className={`hkp-chip${i === 0 ? ' hkp-chip--aktif' : ''}`}>{t(`hooks.niche.${n.id}`)}</button>
        ))}
      </div>

      <div className="hkp-tapis">
        <span className="hkp-tapis-label">{t('hooks.filter.category')}</span>
        {KATEGORI.map((k, i) => (
          <button type="button" key={k} className={`hkp-chip${i === 0 ? ' hkp-chip--aktif' : ''}`}>{t(`hooks.cat.${k}`)}</button>
        ))}
      </div>

      {/* Personalizer — ganjaran utama selepas daftar */}
      <div className="hkp-jampi">
        <Wand2 size={18} strokeWidth={1.9} style={{ color: 'var(--s-ink-2)', flex: 'none' }} />
        <div style={{ flex: 1, minWidth: 220 }}>
          <b>{t('hooks.personal.title')}</b>
          <span>{t('hooks.personal.desc')}</span>
        </div>
        {awam
          ? <span className="hkp-kuncilabel"><Lock size={13} strokeWidth={1.9} /> {t('hooks.personal.locked')}</span>
          : <button type="button" className="hkp-b" style={{ flex: 'none' }}>{t('hooks.personal.cta')}</button>}
      </div>

      <div className="hkp-grid">
        {HOOKS.map((h) => (
          <div className="hkp-kad" key={h.teks}>
            <div className="hkp-kad-atas">
              <div style={{ display: 'flex', gap: 5, alignItems: 'center', flexWrap: 'wrap' }}>
                <span className="hkp-tag">{t(`hooks.cat.${h.kategori}`)}</span>
                <span className="hkp-tag hkp-tag--niche">{t(`hooks.niche.${h.niche}`)}</span>
              </div>
              <button type="button" className="hkp-suka" aria-label={t('hooks.card.save')}><Heart size={16} strokeWidth={1.9} /></button>
            </div>
            <p>{h.teks}</p>
            <div className="hkp-kad-bawah">
              {h.disalin
                ? <button type="button" className="hkp-b hkp-b--siap hkp-b--kecil"><Check size={14} strokeWidth={2} /> {t('hooks.card.copied')}</button>
                : <button type="button" className="hkp-b hkp-b--kecil"><Copy size={14} strokeWidth={1.9} /> {t('hooks.card.copy')}</button>}
              <button type="button" className="hkp-b"><Play size={14} strokeWidth={1.9} /> {t('hooks.card.toVideo')}</button>
            </div>
          </div>
        ))}
      </div>

      {/* Tirai berkunci HANYA untuk pelawat. Selepas log masuk library
          terbuka penuh — yang berbayar ialah menjadikannya video. */}
      {awam ? (
        <div className="hkp-tirai">
          <div className="hkp-tirai-grid" aria-hidden="true">
            {HOOKS_KABUR.map((teks) => <div className="hkp-tirai-kad" key={teks}>{teks}</div>)}
          </div>
          <div className="hkp-tudung">
            <Lock size={24} strokeWidth={1.9} style={{ color: 'var(--s-ink)' }} />
            <h3>{t('hooks.wall.title')}</h3>
            <p>{t('hooks.wall.desc')}</p>
            <button type="button" className="hkp-cta">{t('hooks.wall.cta')} <ArrowRight size={15} strokeWidth={1.9} /></button>
          </div>
        </div>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
          <button type="button" className="hkp-b" style={{ flex: 'none', padding: '9px 20px' }}>
            {t('hooks.loadMore', { n: 9 })} <span style={{ color: 'var(--s-ink-3)' }}>{t('hooks.remaining', { n: 825 })}</span>
          </button>
        </div>
      )}

      <div className="hkp-seksyen">
        <div className="hkp-kepala">
          <h2>{t('hooks.more.title')}</h2>
          <p>{t('hooks.more.desc')}</p>
        </div>
        <div className="hkp-langkah">
          {LANGKAH.map((l) => {
            /* ESLint webapp tiada jsx-uses-vars untuk parameter destructured —
               ikon mesti melalui const bernama. */
            const IkonLangkah = l.Ikon;
            return (
              <div className="hkp-langkah-kad" key={l.k}>
                <span className="hkp-langkah-ikon"><IkonLangkah size={17} strokeWidth={1.9} /></span>
                <b>{t(`${l.k}.title`)}</b>
                <span>{t(`${l.k}.desc`)}</span>
              </div>
            );
          })}
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 18 }}>
          <button type="button" className="hkp-cta">
            {awam ? t('hooks.more.ctaPublic') : t('hooks.more.ctaApp')} <ArrowRight size={15} strokeWidth={1.9} />
          </button>
        </div>
      </div>

      {/* Ejen — permukaan TERBALIK (corak sama kad Extension pada rel) */}
      <div className="hkp-ejen">
        <div>
          <span className="hkp-ejen-pil"><Users size={13} strokeWidth={1.9} /> {t('hooks.agent.pill')}</span>
          <h2>{t('hooks.agent.title')}</h2>
          <ul>
            {KELEBIHAN_EJEN.map((k) => (
              <li key={k}><Check size={15} strokeWidth={2} /> {t(k)}</li>
            ))}
          </ul>
        </div>
        <div className="hkp-ejen-kanan">
          <b>{t('hooks.agent.linkLabel')}</b>
          <div className="hkp-link">
            <Link2 size={14} strokeWidth={1.9} style={{ flex: 'none' }} />
            <span>sesaat.ai/hooks?ref=AFR-ANDA1</span>
          </div>
          <button type="button" className="hkp-b hkp-b--ejen"><Copy size={14} strokeWidth={1.9} /> {t('hooks.agent.copyLink')}</button>
          <p className="hkp-ejen-nota">
            <CalendarDays size={12} strokeWidth={1.9} style={{ display: 'inline', verticalAlign: '-2px', marginRight: 5 }} />
            {t('hooks.agent.packNote')}
          </p>
        </div>
      </div>
    </div>
  );
}
